import React, { useLayoutEffect } from "react";
import secureLocalStorage from "react-secure-storage";
import "./LanguageTranslate.css";
const LanguageTranslate = () => {
  let scriptAppended = false;
  let addScript;

  useLayoutEffect(() => {
    if (!scriptAppended) {
      document.getElementById("trans-load").style.display = "flex";

      const googleTranslateElementInit = () => {
        new window.google.translate.TranslateElement(
          {
            pageLanguage: "en",
            includedLanguages: "en,es",
            autoDisplay: false,
          },
          "google_translate_element"
        );
        setTimeout(() => {
          const selectElement = document.querySelector(".goog-te-combo");
          if (selectElement) {
            selectElement.value = "es"; // Select Spanish
            selectElement.dispatchEvent(new Event("change")); // Trigger translation
          }
        }, 500);
        setTimeout(() => {
          document.getElementById("trans-load").style.display = "none";
        }, 1200);
      };
      addScript = document.createElement("script");
      addScript.src =
        "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
      addScript.async = true;
      document.body.appendChild(addScript);
      window.googleTranslateElementInit = googleTranslateElementInit;
      scriptAppended = true;
    }

    secureLocalStorage.setItem("panel", "user");
    return () => {
      if (addScript && addScript.parentNode === document.body) {
        document.body.removeChild(addScript);
      }
    };
  }, []);
  return (
    <>
      <div className="fix-white translator-loader" id="trans-load">
        <div class="loader-goal"></div>
      </div>
      <div className="translation-box">
        <div id="google_translate_element"></div>
      </div>
    </>
  );
};
export default LanguageTranslate;
